import React from "react";
import {C} from "../styles";

const MINI_CHARTE = [
    "Je critique les décisions et les pratiques, pas la dignité des personnes.",
    "Je distingue les faits que j'ai constatés, ce qu'on m'a rapporté et mon opinion.",
    "Je n'insulte pas, ne menace pas et ne harcèle personne.",
    "Je ne révèle ni l'identité ni les données personnelles d'un collègue ou d'un tiers.",
    "Je ne publie aucun document ou renseignement couvert par une obligation de secret ou de discrétion.",
    "Pour une situation individuelle sensible, j'utilise la demande d'aide confidentielle.",
    "Je vote, soutiens et signale de bonne foi, sans manipulation ni compte multiple.",
    "Je respecte les opinions différentes et je contribue au thème du fil.",
    "Je sais que mon pseudonyme me protège à l'affichage, mais ne me rend pas irresponsable.",
    "Je peux signaler tout contenu malveillant ; la modération protège le débat et ne censure pas la critique légitime.",
];

export function goToCgu() {
    window.history.pushState({}, "", "/cgu");
    window.dispatchEvent(new PopStateEvent("popstate"));
}

export default function CguAcceptance({accepted, onChange, error}) {
    return (
        <div style={{marginBottom: 12}}>
            <details open style={{
                border: `1px solid ${C.border}`,
                borderRadius: 10,
                padding: "10px 12px",
                marginBottom: 10,
                backgroundColor: "#FAFAF8",
            }}>
                <summary style={{fontWeight: 700, fontSize: 13, cursor: "pointer", color: C.text}}>
                    Mini-charte de participation
                </summary>
                <ol style={{margin: "8px 0 4px", paddingLeft: 20, fontSize: 12.5, color: C.textMuted, lineHeight: 1.6}}>
                    {MINI_CHARTE.map((rule, i) => <li key={i}>{rule}</li>)}
                </ol>
                <button
                    type="button"
                    onClick={goToCgu}
                    style={{
                        background: "none", border: "none", padding: 0, marginTop: 4,
                        font: "inherit", fontSize: 12.5, color: C.primary,
                        textDecoration: "underline", cursor: "pointer",
                    }}
                >
                    Lire les Conditions générales d'utilisation complètes
                </button>
            </details>

            <label style={{display: "flex", alignItems: "flex-start", gap: 8, fontSize: 12.5, color: C.text, cursor: "pointer"}}>
                <input
                    type="checkbox"
                    checked={accepted}
                    onChange={e => onChange(e.target.checked)}
                    style={{marginTop: 2}}
                />
                <span>
                    J'ai pris connaissance de la mini-charte et j'accepte les{" "}
                    <button
                        type="button"
                        onClick={goToCgu}
                        style={{
                            background: "none", border: "none", padding: 0,
                            font: "inherit", color: C.primary, textDecoration: "underline", cursor: "pointer",
                        }}
                    >
                        Conditions générales d'utilisation
                    </button>{" "}
                    de Paroles d'Agents.
                </span>
            </label>

            {error && (
                <p style={{margin: "6px 0 0", fontSize: 12.5, color: C.danger}}>{error}</p>
            )}
        </div>
    );
}
